import type { FC, ReactNode } from 'react'

import { BadgePercent, Landmark, ScrollText, Wallet } from 'lucide-react'

const facts = [
    {
        icon: Landmark,
        title: 'Fiscalizado pelo Banco Central',
        description: 'Administradoras de consórcio são autorizadas e supervisionadas pelo BC.'
    },
    {
        icon: ScrollText,
        title: 'Lei 11.795/2008',
        description: 'Regras claras para contemplação, reajustes e devoluções.'
    },
    {
        icon: BadgePercent,
        title: 'Sem juros',
        description: 'O custo é a taxa de administração, diluída no prazo do plano.'
    },
    {
        icon: Wallet,
        title: 'Sem entrada',
        description: 'Você começa pagando apenas a primeira parcela.'
    }
]

export const TrustStrip: FC = (): ReactNode => {
    return (
        <section aria-label='Segurança do consórcio' className='border-y border-border bg-card/70'>
            <ul className='mx-auto grid max-w-7xl gap-x-8 gap-y-7 px-5 py-10 sm:grid-cols-2 sm:px-8 lg:grid-cols-4'>
                {facts.map(fact => (
                    <li key={fact.title} className='flex items-start gap-4'>
                        <span className='grid size-11 shrink-0 place-items-center rounded-xl bg-sand text-bronze'>
                            <fact.icon aria-hidden='true' className='size-5' />
                        </span>

                        <div>
                            <p className='font-semibold text-foreground'>
                                {fact.title}
                            </p>

                            <p className='mt-1 text-sm leading-relaxed text-muted-foreground'>
                                {fact.description}
                            </p>
                        </div>
                    </li>
                ))}
            </ul>
        </section>
    )
}
